export { observer, enableStaticRendering } from "mobx-react-lite";
